var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import { history } from '@idp/routables';
import * as React from 'react';
import { Route, Router, Switch } from 'react-router-dom';
import './App.scss';
import OfferContainer from './components/Offer/Offer.container';
import * as Loadable from 'react-loadable';
import { StoreProvider } from '@idp/state-manager';
import { GlobalNav } from '@idp/ui-components';
import { CustomerTypes, SourceTypes, Types, CartType } from '@idp/ui-components/components/global/GlobalNav/GlobalNavProps';
import { StateProvider } from './services/state-provider';
import { getConnectedCarOrderSrc, getCookie, getFlowType } from './utils/UtilityFunctions';
import ATTBannerLogo from './components/ATTBannerLogo';
var Sng = Loadable({
    loader: function () { return import('./components/Sng'); },
    loading: function () { return (React.createElement("div", null, "Loading...")); },
});
var customerType = CustomerTypes.CONSUMER;
var App = /** @class */ (function (_super) {
    __extends(App, _super);
    function App(props) {
        var _this = _super.call(this, props) || this;
        _this.state = {
            showGlobalNav: true
        };
        _this.globalNavRef = React.createRef();
        // this.halocAuthService = new HalocAuthenticationService();
        _this.stateManager = StateProvider.getStateManagerInstance();
        return _this;
        // this.halocAuthService.checkHalocAuth('sales');
    }
    App.prototype.componentDidMount = function () {
        var _a, _b;
        if (this.globalNavRef) {
            (_b = (_a = this.globalNavRef) === null || _a === void 0 ? void 0 : _a.current) === null || _b === void 0 ? void 0 : _b.scrollIntoView(true);
        }
    };
    App.prototype.componentWillMount = function () {
        var url = location.href;
        // console.log("URL --", url)
        var queryParam = url.split('?')[1];
        // handoffToken needs to check in session when coming back from login page for EAP onDevice Activation.
        var wirelessDetailsInSM = this.stateManager.get('appShell', 'wirelessDetails');
        if (queryParam || getConnectedCarOrderSrc([]) || getFlowType() || (wirelessDetailsInSM && wirelessDetailsInSM.handoffToken)) {
            var parmaArry = queryParam === null || queryParam === void 0 ? void 0 : queryParam.split('&');
            if (((parmaArry === null || parmaArry === void 0 ? void 0 : parmaArry.includes('hideGN=true')) || (parmaArry === null || parmaArry === void 0 ? void 0 : parmaArry.includes('hidegn=true'))) ||
                (parmaArry && parmaArry.filter(function (param) { return param.includes('handoffToken='); }).length > 0) ||
                (wirelessDetailsInSM && wirelessDetailsInSM.handoffToken) ||
                (getConnectedCarOrderSrc(parmaArry)) || getFlowType()) {
                this.setState({ showGlobalNav: false });
            }
            else {
                this.setState({ showGlobalNav: true });
            }
        }
        else {
            this.setState({ showGlobalNav: true });
        }
        if (url && (url.indexOf('/buy/wireless') > -1
            || url.indexOf('/buy/cart') > -1
            || url.indexOf('/buy/checkout') > -1)) {
            if (getCookie('DTAB')) {
                customerType = CustomerTypes.SMB;
            }
        }
    };
    App.prototype.render = function () {
        return (React.createElement(React.Fragment, null,
            React.createElement("div", { ref: this.globalNavRef },
                this.state.showGlobalNav &&
                    React.createElement("div", null,
                        React.createElement(GlobalNav, { options: {
                                className: 'hydrated',
                                customerType: customerType,
                                source: SourceTypes.JSONPRIME,
                                type: Types.HEADER,
                                cartType: CartType.IDPCART,
                                excludeCoreElements: 'search',
                            } })),
                getFlowType() && React.createElement(ATTBannerLogo, null),
                React.createElement(StoreProvider, { initialState: {} },
                    React.createElement(Router, { history: history },
                        React.createElement(Switch, null,
                            React.createElement(Route, { path: "/snglanding", component: Sng }),
                            React.createElement(Route, { path: "/", component: OfferContainer })))),
                this.state.showGlobalNav &&
                    React.createElement("div", null,
                        React.createElement(GlobalNav, { options: {
                                customerType: customerType,
                                source: SourceTypes.JSONPRIME,
                                type: Types.FOOTER,
                            } }))),
            !this.state.showGlobalNav &&
                React.createElement("link", { rel: "stylesheet", type: "text/css", href: 'https://www.att.com/ui/frameworks/css/v1.0.0/core-global-fonts.min.css' })));
    };
    return App;
}(React.Component));
export default App;
//# sourceMappingURL=App.js.map


//////////////////
// WEBPACK FOOTER
// ./node_modules/@idse/core/App.js
// module id = 990
// module chunks = 8